(function () {
  'use strict';

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const money = (cents) => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'ZAR';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return `R${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  function initMenu() {
    const button = qs('[data-menu]');
    const nav = qs('[data-mobile]');
    if (!button || !nav) return;
    button.addEventListener('click', () => {
      const open = nav.classList.toggle('open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function initProduct(root) {
    const variantsScript = qs('[data-product-variants]', root);
    const form = qs('.js-product-form', root);
    if (!variantsScript || !form) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      console.error('HOL: unable to parse product variants', error);
      return;
    }

    const hiddenId = qs('[data-variant-id]', form);
    const price = qs('[data-product-price]', root);
    const compare = qs('[data-product-compare]', root);
    const availability = qs('[data-product-availability]', root);
    const addButton = qs('[data-add-to-cart]', root);
    const mainImage = qs('[data-main-product-image]', root);
    const message = qs('[data-product-message]', root);
    const mobileBuy = qs('[data-mobile-buy]');
    const mobilePrice = qs('[data-mobile-price]', mobileBuy || document);
    const mobileAdd = qs('[data-mobile-add]', mobileBuy || document);
    const optionGroups = qsa('[data-option-group]', form);
    const quoteLinks = qsa('[data-product-quote-link]', root);
    const selection = [];

    optionGroups.forEach((group) => {
      const index = Number(group.dataset.optionIndex);
      const active = qs('[data-option-choice].is-active', group);
      const select = qs('[data-option-select]', group);
      selection[index] = active ? active.dataset.optionValue : (select ? select.value : '');
    });

    const findVariant = (candidateSelection = selection) => variants.find((variant) =>
      variant.options.every((value, index) => String(value) === String(candidateSelection[index]))
    );

    const optionCanResolve = (index, candidate, role) => variants.some((variant) => {
      if (!variant.available || String(variant.options[index]) !== String(candidate)) return false;
      if (role === 'color') return true;
      return variant.options.every((value, optionIndex) => {
        if (optionIndex === index) return true;
        const otherGroup = optionGroups.find((group) => Number(group.dataset.optionIndex) === optionIndex);
        const otherRole = otherGroup ? otherGroup.dataset.optionRole : 'other';
        if (role === 'size' && otherRole === 'size') return true;
        const selected = selection[optionIndex];
        return selected ? String(value) === String(selected) : true;
      });
    });

    const updateChoiceAvailability = () => {
      optionGroups.forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        qsa('[data-option-choice]', group).forEach((choice) => {
          const possible = optionCanResolve(index, choice.dataset.optionValue, group.dataset.optionRole || 'other');
          choice.classList.toggle('is-unavailable', !possible);
          choice.setAttribute('aria-disabled', possible ? 'false' : 'true');
        });
      });
    };

    const updateQuoteLinks = (variant) => {
      quoteLinks.forEach((link) => {
        const base = link.dataset.quoteBase || link.getAttribute('href') || '/pages/request-a-quote';
        try {
          const url = new URL(base, window.location.origin);
          url.searchParams.set('source', 'product');
          url.searchParams.set('product', link.dataset.productTitle || document.title);
          url.searchParams.set('product_url', link.dataset.productUrl || window.location.pathname);
          if (variant) {
            url.searchParams.set('variant', variant.title || variant.options.join(' / '));
            url.searchParams.set('variant_id', variant.id);
          }
          link.href = `${url.pathname}${url.search}${url.hash}`;
        } catch (e) {
          /* Keep server-rendered fallback URL. */
        }
      });
    };

    let updateSizeRun = () => {};

    const applyVariant = (variant) => {
      if (!variant) {
        if (hiddenId) hiddenId.value = '';
        if (availability) availability.textContent = 'Unavailable combination';
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Unavailable';
        }
        if (mobileAdd) {
          mobileAdd.disabled = true;
          mobileAdd.textContent = 'Unavailable';
        }
        updateQuoteLinks(null);
        updateSizeRun();
        return;
      }

      if (hiddenId) hiddenId.value = variant.id;
      if (price) price.textContent = variant.priceFormatted;
      if (mobilePrice) mobilePrice.textContent = variant.priceFormatted;

      if (compare) {
        if (Number(variant.compareAt) > Number(variant.price)) {
          compare.textContent = variant.compareAtFormatted;
          compare.classList.remove('is-hidden');
        } else {
          compare.textContent = '';
          compare.classList.add('is-hidden');
        }
      }

      if (availability) availability.innerHTML = variant.available ? '<span class="status-dot"></span> In stock' : 'Sold out';
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
      if (mobileAdd) {
        mobileAdd.disabled = !variant.available;
        mobileAdd.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }

      if (variant.image && mainImage) {
        mainImage.classList.add('is-changing');
        const preload = new Image();
        preload.onload = () => {
          mainImage.src = variant.image;
          mainImage.removeAttribute('srcset');
          requestAnimationFrame(() => mainImage.classList.remove('is-changing'));
        };
        preload.src = variant.image;
      }

      updateQuoteLinks(variant);
      updateSizeRun();

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    optionGroups.forEach((group) => {
      const index = Number(group.dataset.optionIndex);
      qsa('[data-option-choice]', group).forEach((choice) => {
        choice.addEventListener('click', () => {
          if (choice.getAttribute('aria-disabled') === 'true') return;
          selection[index] = choice.dataset.optionValue;
          qsa('[data-option-choice]', group).forEach((item) => {
            const active = item === choice;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          const label = qs('[data-selected-option]', group);
          if (label) label.textContent = choice.dataset.optionValue;
          updateChoiceAvailability();
          applyVariant(findVariant());
        });
      });

      const select = qs('[data-option-select]', group);
      if (select) {
        select.addEventListener('change', () => {
          selection[index] = select.value;
          const label = qs('[data-selected-option]', group);
          if (label) label.textContent = select.value;
          updateChoiceAvailability();
          applyVariant(findVariant());
        });
      }
    });

    qsa('[data-product-thumb]', root).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        qsa('[data-product-thumb]', root).forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        mainImage.classList.add('is-changing');
        const src = thumb.dataset.imageSrc;
        const preload = new Image();
        preload.onload = () => {
          mainImage.src = src;
          mainImage.removeAttribute('srcset');
          requestAnimationFrame(() => mainImage.classList.remove('is-changing'));
        };
        preload.src = src;
      });
    });

    const qtyInput = qs('[data-qty-input]', form);
    const minus = qs('[data-qty-minus]', form);
    const plus = qs('[data-qty-plus]', form);
    if (qtyInput && minus && plus) {
      minus.addEventListener('click', () => { qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) - 1); });
      plus.addEventListener('click', () => { qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) + 1); });
      qtyInput.addEventListener('change', () => { qtyInput.value = Math.max(1, Number(qtyInput.value) || 1); });
    }

    if (mobileAdd) {
      mobileAdd.addEventListener('click', () => {
        if (addButton && !addButton.disabled) addButton.click();
      });
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (message) message.textContent = '';
      if (!hiddenId || !hiddenId.value || (addButton && addButton.disabled)) return;
      await addFormToCart(form, addButton, message);
    });

    const sizeRun = qs('[data-size-run]', root);
    if (sizeRun) {
      const sizeIndex = Number(sizeRun.dataset.sizeOptionIndex);
      const colorIndexRaw = sizeRun.dataset.colorOptionIndex;
      const colorIndex = colorIndexRaw === '' || typeof colorIndexRaw === 'undefined' ? null : Number(colorIndexRaw);
      const rows = qsa('[data-size-run-row]', sizeRun);
      const countNode = qs('[data-size-run-count]', sizeRun);
      const totalNode = qs('[data-size-run-total]', sizeRun);
      const addRunButton = qs('[data-size-run-add]', sizeRun);
      const runMessage = qs('[data-size-run-message]', sizeRun);
      const runColour = qs('[data-size-run-colour]', sizeRun);
      const runQuote = qs('[data-size-run-quote]', sizeRun);

      const variantForSize = (sizeValue) => {
        const candidate = selection.slice();
        candidate[sizeIndex] = sizeValue;
        return findVariant(candidate);
      };

      const sizeRunState = () => {
        const items = [];
        let count = 0;
        let total = 0;
        rows.forEach((row) => {
          const input = qs('[data-size-run-input]', row);
          const qty = Math.max(0, Number(input && input.value) || 0);
          const variant = variantForSize(row.dataset.sizeValue);
          if (qty > 0 && variant && variant.available) {
            items.push({ id: Number(variant.id), quantity: qty });
            count += qty;
            total += Number(variant.price) * qty;
          }
        });
        return { items, count, total };
      };

      const updateSizeRunQuote = (state) => {
        if (!runQuote) return;
        try {
          const url = new URL(runQuote.dataset.quoteBase || '/pages/request-a-quote', window.location.origin);
          url.searchParams.set('source', 'size-run');
          url.searchParams.set('product', runQuote.dataset.productTitle || document.title);
          url.searchParams.set('product_url', runQuote.dataset.productUrl || window.location.pathname);
          if (colorIndex !== null && selection[colorIndex]) url.searchParams.set('variant', selection[colorIndex]);
          url.searchParams.set('quantity', state.count);
          const breakdown = rows.map((row) => {
            const input = qs('[data-size-run-input]', row);
            const qty = Math.max(0, Number(input && input.value) || 0);
            return qty ? `${row.dataset.sizeValue}:${qty}` : '';
          }).filter(Boolean).join(' / ');
          if (breakdown) url.searchParams.set('size_breakdown', breakdown);
          runQuote.href = `${url.pathname}${url.search}`;
        } catch (e) {
          /* Keep fallback. */
        }
      };

      updateSizeRun = () => {
        if (runColour && colorIndex !== null) runColour.textContent = selection[colorIndex] || 'Selected colour';
        rows.forEach((row) => {
          const variant = variantForSize(row.dataset.sizeValue);
          const input = qs('[data-size-run-input]', row);
          const line = qs('[data-size-run-line]', row);
          const available = Boolean(variant && variant.available);
          row.classList.toggle('is-unavailable', !available);
          if (input) input.disabled = !available;
          if (!available && input) input.value = 0;
          const qty = Math.max(0, Number(input && input.value) || 0);
          if (line) line.textContent = available && qty > 0 ? money(Number(variant.price) * qty) : (available ? money(variant.price) : 'Unavailable');
        });
        const state = sizeRunState();
        if (countNode) countNode.textContent = state.count;
        if (totalNode) totalNode.textContent = money(state.total);
        if (addRunButton) addRunButton.disabled = state.count === 0;
        updateSizeRunQuote(state);
      };

      rows.forEach((row) => {
        const input = qs('[data-size-run-input]', row);
        const rowMinus = qs('[data-size-run-minus]', row);
        const rowPlus = qs('[data-size-run-plus]', row);
        if (rowMinus) rowMinus.addEventListener('click', () => {
          if (!input || input.disabled) return;
          input.value = Math.max(0, (Number(input.value) || 0) - 1);
          updateSizeRun();
        });
        if (rowPlus) rowPlus.addEventListener('click', () => {
          if (!input || input.disabled) return;
          input.value = Math.max(0, (Number(input.value) || 0) + 1);
          updateSizeRun();
        });
        if (input) input.addEventListener('input', () => {
          input.value = Math.max(0, Number(input.value) || 0);
          updateSizeRun();
        });
      });

      if (addRunButton) {
        addRunButton.addEventListener('click', async () => {
          const state = sizeRunState();
          if (!state.items.length) return;
          const original = addRunButton.textContent;
          if (runMessage) runMessage.textContent = '';
          addRunButton.disabled = true;
          addRunButton.textContent = 'Adding size run…';
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: state.items })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || data.message || 'Unable to add the size run.');
            rows.forEach((row) => {
              const input = qs('[data-size-run-input]', row);
              if (input) input.value = 0;
            });
            updateSizeRun();
            await refreshCart(true);
            if (runMessage) runMessage.textContent = `${state.count} garments added to bag.`;
          } catch (error) {
            if (runMessage) runMessage.textContent = error.message || 'Unable to add the size run.';
          } finally {
            addRunButton.textContent = original;
            updateSizeRun();
          }
        });
      }
    }

    updateChoiceAvailability();
    applyVariant(findVariant() || variants.find((variant) => String(variant.id) === String(hiddenId && hiddenId.value)) || variants[0]);
  }

  async function addFormToCart(form, button, message) {
    const original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item.');
      await refreshCart(true);
      if (message) message.textContent = 'Added to bag.';
    } catch (error) {
      if (message) message.textContent = error.message || 'Unable to add this item.';
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = original || 'Add to bag';
      }
    }
  }

  async function quickAdd(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add item.');
      await refreshCart(true);
    } catch (error) {
      console.error(error);
      button.textContent = 'Try again';
      setTimeout(() => { button.textContent = original; }, 1800);
    } finally {
      button.disabled = false;
      if (button.textContent === 'Adding…') button.textContent = original;
    }
  }

  function initQuickAdd() {
    qsa('[data-quick-add]').forEach((button) => button.addEventListener('click', () => quickAdd(button)));
  }

  function cartDrawer() { return qs('[data-cart-drawer]'); }

  function openCart() {
    const drawer = cartDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-open');
    const close = qs('[data-cart-close]', drawer);
    if (close) close.focus({ preventScroll: true });
  }

  function closeCart() {
    const drawer = cartDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-open');
  }

  async function refreshCart(shouldOpen) {
    const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await response.json();
    renderCart(cart);
    if (shouldOpen) openCart();
    return cart;
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function renderCart(cart) {
    qsa('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    const drawer = cartDrawer();
    if (!drawer) return;
    const itemsRoot = qs('[data-cart-items]', drawer);
    const footer = qs('[data-cart-footer]', drawer);
    const total = qs('[data-cart-total]', drawer);
    if (total) total.textContent = money(cart.total_price);

    if (!cart.items.length) {
      if (itemsRoot) itemsRoot.innerHTML = '<div class="hol-cart-empty"><p>Your bag is empty.</p><a href="/collections/all">Shop blanks →</a></div>';
      if (footer) footer.hidden = true;
      return;
    }

    if (footer) footer.hidden = false;
    if (itemsRoot) {
      itemsRoot.innerHTML = cart.items.map((item) => {
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span>${escapeHtml(item.variant_title)}</span>` : '';
        const image = item.image ? `<a href="${escapeHtml(item.url)}" class="hol-cart-item__image"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy"></a>` : '<div class="hol-cart-item__image"></div>';
        return `<div class="hol-cart-item" data-cart-key="${escapeHtml(item.key)}">
          ${image}
          <div class="hol-cart-item__info">
            <a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a>
            ${variant}
            <div class="hol-cart-item__qty">
              <button type="button" data-cart-qty="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <div class="hol-cart-item__end">
            <span>${money(item.final_line_price)}</span>
            <button type="button" data-cart-remove>Remove</button>
          </div>
        </div>`;
      }).join('');
    }

    const threshold = 100000;
    const remaining = Math.max(0, threshold - cart.total_price);
    const progress = Math.min(100, (cart.total_price / threshold) * 100);
    const shippingMessage = qs('[data-shipping-message]', drawer);
    const shippingBar = qs('[data-shipping-bar]', drawer);
    if (shippingMessage) shippingMessage.textContent = remaining > 0 ? `${money(remaining)} away from free shipping` : 'You qualify for free shipping';
    if (shippingBar) shippingBar.style.width = `${progress}%`;
  }

  async function changeCartLine(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) })
    });
    const cart = await response.json();
    if (!response.ok) throw new Error(cart.description || cart.message || 'Unable to update bag.');
    renderCart(cart);
  }

  function initCart() {
    qsa('[data-cart-open]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        refreshCart(true).catch(() => { window.location.href = link.href; });
      });
    });
    qsa('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
    document.addEventListener('click', (event) => {
      const qty = event.target.closest('[data-cart-qty]');
      const remove = event.target.closest('[data-cart-remove]');
      if (!qty && !remove) return;
      const line = event.target.closest('[data-cart-key]');
      if (!line) return;
      changeCartLine(line.dataset.cartKey, remove ? 0 : qty.dataset.cartQty).catch(console.error);
    });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });
  }

  function initCollection() {
    qsa('[data-sort-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  function initQuoteBuilder(builder) {
    const form = qs('form', builder);
    const summary = qs('[data-quote-summary]', builder);
    const whatsapp = qs('[data-quote-whatsapp]', builder);
    if (!form || !summary) return;

    const params = new URLSearchParams(window.location.search);
    ['product', 'variant', 'quantity', 'size_breakdown', 'product_url'].forEach((key) => {
      const field = qs(`[data-prefill="${key}"]`, form);
      if (field && params.get(key)) field.value = params.get(key);
    });

    const buildLines = () => {
      const lines = [];
      qsa('[data-quote-field]', form).forEach((field) => {
        if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) return;
        const value = String(field.value || '').trim();
        if (!value) return;
        lines.push([field.dataset.quoteField, value]);
      });
      const branding = qsa('[data-quote-checkbox]:checked', form).map((field) => field.dataset.quoteCheckbox).filter(Boolean);
      if (branding.length) lines.push(['Branding', branding.join(', ')]);
      return lines;
    };

    const updateSummary = () => {
      const lines = buildLines();
      if (!lines.length) {
        summary.innerHTML = '<p>Complete the fields and your brief will appear here.</p>';
        return;
      }
      summary.innerHTML = lines.map(([label, value]) => `<div><span>${escapeHtml(label)}</span><strong>${escapeHtml(value)}</strong></div>`).join('');
    };

    form.addEventListener('input', updateSummary);
    form.addEventListener('change', updateSummary);

    if (whatsapp) {
      whatsapp.addEventListener('click', () => {
        const number = String(builder.dataset.whatsapp || '').replace(/\D/g, '');
        if (!number) return;
        const lines = buildLines();
        const text = ['Hi HOL MANUFACTURING,', '', "I'd like to request a production quote.", ''];
        lines.forEach(([label, value]) => text.push(`${label}: ${value}`));
        text.push('', 'Please assist me with the next steps.');
        window.open(`https://wa.me/${number}?text=${encodeURIComponent(text.join('\n'))}`, '_blank', 'noopener');
      });
    }

    updateSummary();
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMenu();
    qsa('[data-product-root]').forEach(initProduct);
    qsa('[data-quote-builder]').forEach(initQuoteBuilder);
    initQuickAdd();
    initCart();
    initCollection();
    refreshCart(false).catch(() => {});
  });
})();
